<!-- Feedback Dialog Content -->
<div class="feedback-dialog-wrapper">

    <div *ngIf="interviewMode === 'Offline' && loadingOfflinePanelMembers" class="feedback-offline-loading">
        <p-progressSpinner [style]="{height: '32px', width: '32px'}" strokeWidth="4"></p-progressSpinner>
        <span>Loading panel members...</span>
    </div>

    <!-- Offline with panel members -->
    <div *ngIf="interviewMode === 'Offline' && !loadingOfflinePanelMembers && offlinePanelMembers.length > 0" class="feedback-offline-with-panel">
        <div class="panel-members-sidebar offline-panel-sidebar">
            <div class="panel-members-title">PANEL MEMBERS ({{ offlinePanelMembers.length }})</div>
            <div class="panel-member-item" *ngFor="let member of offlinePanelMembers"
                [class.active]="(member.isVirtual && selectedOfflinePanelMemberFormId === null && selectedOfflinePanelMemberId === member.submitted_by_id) || (!member.isVirtual && selectedOfflinePanelMemberFormId === member.form_id)"
                (click)="selectOfflinePanelMember(member)">
                <div class="panel-member-avatar" [style.background-color]="getAvatarColor(member.submitted_by_name)">
                    {{ getInitials(member.submitted_by_name) }}
                </div>
                <div class="panel-member-info">
                    <span class="panel-member-name">
                        {{ member.submitted_by_name }}
                        <span *ngIf="isCurrentUserOffline(member)" class="you-tag">(You)</span>
                    </span>
                    <span class="panel-member-date" *ngIf="member.isVirtual" style="color: #ef4444;">Not Submitted</span>
                    <span class="panel-member-date" *ngIf="!member.isVirtual">
                        <i class="pi pi-check-circle" style="color: #22c55e; font-size: 11px;"></i>
                        {{ member.submitted_date | date: 'dd-MM-yyyy hh:mm a' }}
                    </span>
                </div>
                <i class="pi pi-chevron-right panel-member-arrow"></i>
            </div>
        </div>
        <div class="feedback-offline-form-area neo-scrollbar">
            <ng-container *ngTemplateOutlet="feedbackFormContentTpl"></ng-container>
        </div>
    </div>

    <ng-container *ngIf="interviewMode !== 'Offline' || (interviewMode === 'Offline' && !loadingOfflinePanelMembers && offlinePanelMembers.length === 0)">
        <ng-container *ngTemplateOutlet="feedbackFormContentTpl"></ng-container>
    </ng-container>
</div>

<ng-template #feedbackFormContentTpl>
    <!-- Feedback Complete Message (Offline Mode) -->
    <div *ngIf="interviewMode === 'Offline' && feedbackSubmitted && displayFeedback" class="feedback-complete-state">
        <div class="complete-icon">
            <i class="pi pi-check-circle"></i>
        </div>
        <h2>Feedback Submitted Successfully</h2>
        <p>You can edit your feedback if needed</p>
        <button pButton label="Edit Feedback" class="p-button-primary edit-feedback-btn" (click)="enableEditMode()">
        </button>
    </div>

    <!-- Feedback Form Content -->
    <div class="feedback-form-content neo-scrollbar" *ngIf="displayFeedback && !feedbackSubmitted">
        
        <!-- Loading State for Form -->
        <div *ngIf="isLoading" class="feedback-loading center-loader">
            <p-progressSpinner [style]="{height: '40px', width: '40px'}" strokeWidth="6" animationDuration="0.5s">
            </p-progressSpinner>
        </div>
        
        <!-- Candidate Profile Section -->
        <div class="section" *ngIf="!onlyFeedbackView && candidateDetails && !isLoading">
            <div class="section-content">
                <div class="section-item no-border">
                    <div class="section-item-content">
                        <div class="candidate-profile-content">
                            <div class="candidate-avatar" [style.background-color]="getAvatarColor(candidateDetails?.candidate_name)">
                                <img *ngIf="candidateDetails?.profilePic" [src]="signedProfileUrl" alt="Profile picture" class="candidate-photo">
                                <span class="candidate-initials" *ngIf="!candidateDetails?.profilePic">
                                    {{ getInitials(candidateDetails?.candidate_name) }}
                                </span>
                            </div>
                            <div class="candidate-info">
                                <h3 class="candidate-name">{{candidateDetails?.candidate_name || '-'}}</h3>
                                <p class="candidate-id">{{candidateDetails?.candidate_uuid || '-'}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Form Sections -->
        <div *ngIf="showForm && !isLoading" class="form-sections">
            <div *ngFor="let section of templateCollections; index as i" class="section">
                <ng-container *ngIf="canShowSection(section)">
                    <div class="section-heading">
                        <h3 class="section-title">{{section[0].displaySection}}</h3>
                    </div>
                    <div class="section-content">
                        <div class="section-item no-border">
                            <div class="section-item-content">
                                <div class="section-contents">
                                    <ng-container *ngFor="let field of section; trackBy: trackByFieldId">
                                        <div *ngIf="field.visible" 
                                             class="section-content-field" 
                                             [attr.element_type]="field.element_type"
                                             [attr.full-grid-col]="field.fieldType === 'file' || field.fieldType === 'multi-file' || field.fieldType === 'checkbox' || field.fieldType === 'radio'">
                                            <app-fields-v2 
                                                [model]="field" 
                                                [preview]="feedbackMode === 'view'" 
                                                [duplicateData]="{}"
                                                [emailVerified]="true"
                                                [preventDropdownAutoOpen]="true"
                                                (checkValidator)="checkValid($event, field)" 
                                                (fieldDataEmitter)="bindData($event, field)"
                                                [markAsTouced]="markAsTouced" 
                                                [eventId]="candidateDetails?.event_uuid || ''"
                                                [fromFeedback]="true">
                                            </app-fields-v2>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Submitted By Info Section (After all sections, before footer) -->
        <div class="submitted-info-footer" *ngIf="feedbackData && (feedbackMode === 'view' || feedbackMode === 'edit') && !isLoading">
            <div class="submitted-details">
                <span class="submitted-label">SUBMITTED BY</span>
                <span class="submitted-value">{{ feedbackData?.submitted_by_name || '-' }}</span>
                <span class="submitted-label">SUBMITTED ON</span>
                <span class="submitted-value">{{ feedbackData?.updated_at ? (feedbackData?.updated_at | date:combinedFormat) : '-'}}</span>
            </div>
        </div>

    </div>
    
    <!-- Footer Section with Submit/Update Button -->
    <div class="feedback-footer" *ngIf="!feedbackSubmitted && showForm && !isLoading && feedbackMode !== 'view'">
        <button pButton pRipple type="button"
            [label]="getSubmitButtonLabel()"
            (click)="submit()" 
            class="submit-feedback-btn" 
            [loading]="submitBtnLoading"
            [disabled]="((feedbackMode === 'create' ? !hasAnyData() : !hasChanges) || submitBtnLoading)">
        </button>
    </div>
</ng-template>